export default __webpack_public_path__ + "static/media/inactive-icon.0f8d7d14.svg";